import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';

function ConfirmedEmail() {
  const [email, setEmail] = useState(null);
  const navigate = useNavigate();

  return (
    <section className="theme-light section m-0 p-0" data-theme="light">
      <div className='fullHeight m-0 p-0 is-flex is-flex-direction-column is-justify-content-space-between'>
        <div>
          {/* Navigation */}
          <div className='columns is-flex is-flex-direction-rows is-justify-content-center'>
            <div className="m-0 p-0 column is-11 is-offset-1"><Navigation /></div>
          </div>
          
          {/* Content */}
          <div className='pb-6 columns is-flex is-flex-direction-rows is-justify-content-center main-content'>
            <div className="m-0 p-0 content column is-6">
              <h1 className='pt-4 px-0 pb-0 m-0'>
                You're in! 🎉
              </h1>
              <h2 className='pt-2 px-0 m-0 is-bold'>
                Future-you is already celebrating.    
              </h2>
              {email ? (
                <h2 className='p-0 m-0'>
                  Your account at <strong>{email}</strong> is confirmed, and Mr. Nudges is officially on standby. Now it's time to start sending yourself brilliantly timed reminders. Need a refresher? Check out our <a href="/how-to" className='textLink'>How to guide</a>. Otherwise, go forth and Nudge like a champ! 🚀
                </h2>
              ) : (
                <h2 className='p-0 m-0'>
                  Your email is confirmed, and Mr. Nudges is officially on standby. Now it's time to start sending yourself brilliantly timed reminders. Need a refresher? Check out our <a href="/how-to" className='textLink'>How to guide</a>. Otherwise, go forth and Nudge like a champ! 🚀
                </h2>
              )}
            </div>
          </div>
        </div>
        
        {/* Footer */}
        <div className='footer m-0 p-0 columns is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
          <div className="m-0 p-0 column is-11 is-10-mobile"><Footer /></div>
        </div>
      </div>
    </section>
  );
}

export default ConfirmedEmail;
